(function () {
  var CHECKIN_PATH = '/pages/summer-body-check-in';
  var LEDGER_ENDPOINT = 'https://hume-summer-body-ledger.netlify.app/.netlify/functions/summer-body-check-in';

  if (window.location.pathname !== CHECKIN_PATH) return;

  function read(formData, key) {
    return String(formData.get(key) || '').trim();
  }

  function showMessage(element, message) {
    if (!element) return;
    element.textContent = message;
    element.hidden = false;
    if (typeof element.focus === 'function') element.focus();
  }

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target.closest('[data-hume-checkin-form]');
      if (!form) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      var success = form.querySelector('[data-checkin-success]');
      var error = form.querySelector('[data-checkin-error]');
      var button = form.querySelector('button[type="submit"]');
      var formData = new FormData(form);

      if (formData.get('company')) {
        showMessage(success, 'Update submitted. We logged this check-in with your giveaway profile.');
        return;
      }

      if (success) success.hidden = true;
      if (error) error.hidden = true;

      var email = read(formData, 'email');
      var checkInNumber = read(formData, 'check_in_number');
      var checkInWindow = read(formData, 'check_in_window');
      var trackingMethod = read(formData, 'tracking_method');
      var progressArea = read(formData, 'progress_area');
      var progressStory = read(formData, 'progress_story');

      if (!email || !checkInNumber || !checkInWindow || !trackingMethod || !progressArea || progressStory.length < 20) {
        showMessage(error, 'Please complete the required fields before submitting your update.');
        return;
      }

      if (button) {
        button.disabled = true;
        button.dataset.originalText = button.textContent;
        button.textContent = 'Submitting...';
      }

      fetch(LEDGER_ENDPOINT, {
        method: 'POST',
        headers: {
          accept: 'application/json',
          'content-type': 'application/json'
        },
        body: JSON.stringify({
          source: 'summer_body_giveaway_check_in',
          campaign: 'Summer Body Giveaway 2026',
          email: email,
          first_name: read(formData, 'first_name'),
          last_name: read(formData, 'last_name'),
          check_in_number: checkInNumber,
          check_in_window: checkInWindow,
          tracking_method: trackingMethod,
          current_weight: read(formData, 'current_weight'),
          scan_count: read(formData, 'scan_count'),
          progress_area: progressArea,
          progress_story: progressStory,
          proof_link: read(formData, 'proof_link'),
          story_permission: formData.get('story_permission') === 'yes',
          company: read(formData, 'company')
        })
      })
        .then(function (response) {
          return response.json().then(function (result) {
            if (!response.ok) throw new Error(result.message || 'Ledger submission failed');
            return result;
          });
        })
        .then(function (result) {
          if (window.klaviyo) {
            window.klaviyo.identify({
              email: email,
              first_name: read(formData, 'first_name'),
              last_name: read(formData, 'last_name'),
              hume_campaign: 'Summer Body Giveaway 2026',
              hume_latest_check_in_number: checkInNumber,
              hume_latest_check_in_window: checkInWindow
            });
            window.klaviyo.track('Summer Body Giveaway Check-In', {
              hume_campaign: 'Summer Body Giveaway 2026',
              hume_signup_source: 'summer_body_giveaway_check_in',
              hume_latest_check_in_number: checkInNumber,
              hume_latest_check_in_window: checkInWindow,
              hume_latest_tracking_method: trackingMethod,
              hume_latest_progress_area: progressArea,
              hume_latest_progress_story: progressStory,
              hume_ledger_submission_id: result.submission_id || '',
              hume_entries_awarded: result.entries_awarded || 0,
              hume_duplicate_check_in: Boolean(result.duplicate)
            });
          }

          form.reset();
          if (window.humeCheckInApplyWindowDefaults) window.humeCheckInApplyWindowDefaults();

          showMessage(
            success,
            result.duplicate
              ? 'Update received. You already earned the entry for this check-in window, so this duplicate was logged but not counted again.'
              : 'Update submitted. We logged this check-in and added this bonus entry to the giveaway ledger.'
          );
        })
        .catch(function (requestError) {
          showMessage(error, requestError.message || 'Something went wrong while saving your check-in. Please try again.');
        })
        .finally(function () {
          if (button) {
            button.disabled = false;
            button.textContent = button.dataset.originalText || 'Submit progress update';
          }
        });
    },
    true
  );
})();
